export const account = {
  profile: 'Profile',
  back: 'Back',
  sectionYourPlan: 'Your plan',
  sectionAccount: 'Account',
  sectionAbout: 'About',
  freePlan: 'Free plan',
  notCoveredByPlan: 'Not covered by a plan',
  noSubscription: 'No active subscription',
  statusLinkedNotCovered: 'Your child is linked — choose a plan to cover them',
  statusFreeTrial: 'Free trial',
  statusGracePeriod: 'Payment issue — access continues for now',
  statusCancelsOn: 'Cancelled — access until {date}, {time}',
  statusCancelled: 'Cancelled — access continues until your plan ends',
  statusLapsed: 'Lapsed — upgrade to resume',
  statusActive: 'Active',
  onFreePlan: "You're on the free plan",
  onFreePlanBody:
    'AI reports and homework assignment are locked. One subscription covers every child you add.',
  upgradeNow: 'Upgrade now',
  startPlan: 'Start plan',
  changePlan: 'Change plan',
  manageSubscription: 'Manage subscription',
  yourDetails: 'Your details',
  language: 'Language',
  logOut: 'Log out',
  termsOfService: 'Terms of service',
  privacyPolicy: 'Privacy policy',
  appVersion: 'Tupai Parent v{version}',
  deleteAccount: 'Delete account',
  errBillingOwnerActive:
    "Your account owns your family's subscription. Cancel the subscription first, then delete your account.",
  errChildrenLinked:
    'You still have children linked to your account. Unlink them first, then delete your account.',
  errDeleteFailed: 'Failed to delete account',
  languageSheetBody: 'Changes the app right away',
  editYourDetails: 'Edit your details',
  name: 'Name',
  phoneNumber: 'Phone number',
  phonePlaceholder: 'Add your phone number here',
  countryCode: 'Country code',
  saving: 'Saving…',
  save: 'Save',
  errNameRequired: 'Name is required',
  errPhoneRequired: 'Phone number is required',
  errContactRequired: 'Enter an email or phone number',
  errPhoneInvalid: 'Enter a valid phone number',
  errSaveFailed: 'Failed to save changes',
  phoneVerifyTitle: 'Verify your new number',
  phoneSendingCode: 'Sending a code…',
  phoneSentTo: 'We sent a 6-digit code to',
  phoneVerifyCta: 'Verify number',
  phoneCancel: 'Cancel',
  phoneTryAgain: 'Try again',
  errPhoneInUse: 'This number is already used by another account.',
  errEmailInUse: 'This email is already in use',
  errPhoneRelogin: 'For your security, log out and log in again, then change your number.',
  deleteSheetAria: 'Delete your account',
  deleteTitle: 'Delete your account?',
  deleteBody: "This can't be undone. Here's what happens:",
  andJoin: 'and',
  deleteBlockedTitle: 'You still have children linked',
  deleteBlockedBody: 'Unlink {names} first, then you can delete your account.',
  deleteHistory: 'Your reports and homework history are permanently deleted.',
  deleteSubscription:
    "An active subscription must be cancelled in your app store — deleting the account doesn't cancel it.",
  deleting: 'Deleting…',
  deleteConfirm: 'Delete my account',
  keepAccount: 'Keep my account',
  trialRibbon: 'Free trial',
  freeDays: 'FREE {days} days',
  perMonth: '/ month',
  current: 'Current',
  close: 'Close',
  allSet: "You're all set",
  planActive: 'Your {tierName} plan is active.',
  planChangeScheduled: 'Change scheduled',
  planChangingOn: 'Changing to {tierName} on {date}',
  planChangingSoon: 'Changing to {tierName} at the end of this billing period',
  planChangeScheduledOn: "You'll stay on your current plan until {date}, then move to {tierName}.",
  planChangeScheduledSoon:
    "You'll stay on your current plan until the end of this billing period, then move to {tierName}.",
  addYourChild: 'Add your child',
  stepYourPlan: 'Step 1 of 2 · Your plan',
  stepChoosePlan: 'Step 1 of 2 · Choose a plan',
  stepHowTrialWorks: 'Step 2 of 2 · How your trial works',
  stepConfirm: 'Step 2 of 2 · Confirm',
  startMyFreeTrial: 'Start free trial',
  switchTo: 'Switch to {tierName}',
  subscribe: 'Subscribe',
  working: 'Working…',
  yourPlan: 'Your plan',
  seatsUsed: '{used} of {total} child seats used',
  onePlanEveryChild: 'One plan, every child',
  tryFamilySolo: 'Try Family Solo for Free',
  onePlanEveryChildBody: 'Reports, homework and unlimited practice.',
  pricingIncluded: '{detail} included.',
  continueLabel: 'Continue',
  pickDifferentPlan: 'Pick a different plan to change it.',
  keepPlan: 'Keep {tierName}',
  alreadyScheduled: 'This change is already scheduled.',
  keepPlanNote: 'Your scheduled change will be cancelled. Nothing else changes.',
  pendingChangeOn: 'Scheduled to change to {tierName} on {date}.',
  pendingChangeSoon: 'Scheduled to change to {tierName} at the end of this billing period.',
  cancelAnytime: 'Cancel anytime, for any reason.',
  cancelAutoRenew:
    'Cancel anytime, for any reason. After the free trial, this subscription automatically renews at the price selected above.',
  manageBilling: 'Manage billing',
  restorePurchases: 'Restore purchases',
  trialHeading: '{days} days. On us.',
  confirmYourPlan: 'Confirm your plan',
  annual: 'Annual',
  annualSave: 'Annual ({pct}% off)',
  monthly: 'Monthly',
  billingPeriod: 'Billing period',
  thenPriceYearly: 'First {days} days free, then {price} a year from {date}.',
  thenPriceMonthly: 'First {days} days free, then {price} a month from {date}.',
  timelineTodayTitle: 'Today',
  timelineTodayBody: 'Reports and homework unlock right away.',
  timelineDay: 'Day {n}',
  timelineReminderBody: "Tupai reminds you here, in the app, that it's ending.",
  timelineBilledBody:
    '{native, select, true {Billed {date}. Cancel any time before then in Google Play.} other {Your trial ends {date}. Add a card in Manage billing before then to keep your plan.}}',
  trialNoCardTitle: 'No card needed today. {price} from {date}',
  trialNoCardBody: 'Nothing is charged unless you add a card in Manage billing.',
  billedToday: 'Billed today',
  proratedNote: 'Charged today, less credit for unused time on your current plan.',
  proratedNoteWeb: 'Charged today, less credit for unused time on your current plan.',
  downgradeNote: 'Starts at the end of your current billing period.',
  nothingToday: 'Nothing today',
  trialEndsNowNote: 'Your free trial ends now and this plan starts right away. Renews {period}.',
  renewsNote: 'Renews {period}. No free trial on this tier.',
  trialAlreadyUsedNote: "Renews {period}. You've already used your free trial.",
  renewYearly: 'yearly',
  renewMonthly: 'monthly',
  finishInApp: 'Finish in the app',
  finishInAppBody:
    'Subscriptions are bought through the store, so this step only works in the Tupai app.',
  errPurchaseFailed: 'Purchase failed. You have not been charged — please try again.',
  errPlanChangeNotReflected:
    'Your payment went through, but your plan is still updating. It should appear shortly — please do not pay again.',
  purchaseLinkedToAnotherAccount:
    'This store subscription is linked to another Tupai account. Sign into the account originally used to subscribe, or contact support. Please do not purchase again to resolve this.',
  purchaseStillSyncing:
    'Your purchase was accepted, but your plan is still updating. Please check again shortly and do not purchase again.',
  restoreStillSyncing:
    'Your store subscription was found, but your plan is still updating. Please try restoring again shortly; you do not need to purchase again.',
  errRestoreFailed: 'Could not restore purchases. Check your connection and try again.',
  errNothingToRestore: 'Nothing to restore on this account.',
  cardNeededToSwitch:
    'Add a card to finish switching to {plan}. It is charged as shown on the previous screen.',
  errAddCard:
    'That payment did not go through. Add or update a card in Manage billing, then try again. Your plan has not changed.',
  checkoutPending:
    'Your purchase is complete, but your plan is still being set up. Please do not pay again.',
  storePurchasePending:
    'Your purchase is waiting for approval or payment. Your plan will update once it is confirmed. Please do not purchase again.',
  checkAgain: 'Check again',
  errLoadPrices: 'Could not load prices. Check your connection.',
  blockedTooManyChildren: 'You have {count} children linked. Unlink one first.',
  managedElsewhere: 'Your plan is managed on {store}',
  managedElsewhereBody: 'Manage changes and cancellation through the store where you subscribed.',
  billingOwnershipUnknown: 'Subscription store unavailable',
  billingOwnershipUnknownBody:
    'We need to confirm where your subscription is managed before you can change plans. Please try again.',
  billingManagementUnavailable:
    'No management link is available for this subscription. Try again, or manage it through the store where you subscribed.',
  errManageBilling: 'Could not open billing management. Check your connection and try again.',
  seatPickerTitle: 'Choose who to keep on {tierName}',
  seatPickerBody:
    'This plan covers {max, plural, one {{max} child} other {{max} children}}. Pick who to keep — the rest will be unlinked.',
  seatPickerKeepCount: '{selected} of {max} selected',
  seatPickerConfirm: 'Confirm and switch plan',
  seatPickerCancel: 'Cancel',
  seatPickerReleaseFailed: "Couldn't unlink one of the children. Nothing was changed — try again.",
  seatPickerKeepConfirm: 'Keep these children',
  seatPickerUpgradeInstead: 'Upgrade instead',
  overLimitBannerBody:
    '{plan} covers {limit, plural, one {{limit} child} other {{limit} children}}, and {linked} are linked. Choose who to keep, or upgrade to keep them all. Everyone keeps full access until you choose.',
  blockedIgcseTitle: 'You have a child on IGCSE',
  blockedIgcseBody:
    'Ask {names} to switch to KSSM or KSSR in their own app first, then you can move to Standard. You can also unlink them from the Children screen.',
  syllabusOverTierTitle: "A child's syllabus is above your plan",
  syllabusOverTierBody:
    'Your plan changed outside the app and no longer covers IGCSE. Ask your child to switch to KSSM or KSSR in their own app, or upgrade to keep IGCSE.',
  tierSolo: '1 parent + 1 child',
  tierDuo: '1 parent + 2 children',
  tierExtended: '1 parent + up to 5 children',
  pricingStandard: 'KSSR and KSSM',
  pricingPremium: 'KSSR, KSSM and IGCSE',
  syllabusQuestion: 'Which syllabus does your child follow?',
  pricingStandardLabel: 'Malaysian only',
  pricingPremiumLabel: 'Malaysian + IGCSE',
  notNow: 'Not now',
  seePlans: 'See plans',
  gateTrialSeatTitle: 'Trials cover one child',
  gateTrialSeatBody:
    'Your free trial covers one child. Convert to a paid plan first, then add more children.',
  gateSeatLimitTitle: 'No student seats left',
  gateSeatLimitBody: 'Your plan has no student seats left. Upgrade to add another child.',
  gateSeatLimitMaxTierTitle: 'No student seats left',
  gateSeatLimitMaxTierBody:
    "Your plan has no student seats left, and it's already our largest plan. We're working on plans for bigger families — check back soon.",
  gotIt: 'Got it',
  gateSeatsOverCapTitle: "You're over your plan's limit",
  gateSeatsOverCapBody:
    'Your plan covers fewer children than you currently have linked. Unlink a child to fit your plan, or upgrade to keep them all.',
  manageChildren: 'Manage children',
  gateFeatureTitle: 'Upgrade to use this',
  gateFeatureBody: 'This feature needs an active subscription.',
  gateUpgradeTitle: 'Not included in your plan',
  gateUpgradeBody:
    'This syllabus needs a higher plan. Upgrade to assign its chapters and download its papers.',
  gateQuotaTitle: "You've hit this month's limit",
  gateQuotaBody: 'You can do this again next month — or upgrade for unlimited access.',
  gateFallbackTitle: 'Not available on your plan',
  gateFallbackBody: 'Upgrade to unlock this.',
  emailInvalid: 'Invalid email address',
  emailRelogin: 'Please log out and sign in again to change your email.',
  emailUpdateFailed: 'Failed to update email.',
  awaitingVerificationPrefix: 'Awaiting verification for',
  awaitingVerificationSuffix: '. Please check your inbox.',
  reauthTitle: 'Confirm your identity',
  reauthBody: 'For your security, please enter your password to change your email address.',
  reauthPasswordLabel: 'Password',
  reauthConfirm: 'Confirm',
  reauthConfirming: 'Confirming...',
  reauthIncorrect: 'Incorrect password. Please try again.',
  reauthFailed: 'Authentication failed.',
  storeNames: {
    PLAY_STORE: 'Google Play',
    APP_STORE: 'the App Store',
    MAC_APP_STORE: 'the App Store',
    STRIPE: 'the web',
    RC_BILLING: 'the web',
    PADDLE: 'the web',
    AMAZON: 'Amazon',
    GALAXY: 'Galaxy Store',
    PROMOTIONAL: 'a promotional grant',
    EXTERNAL: 'another platform',
    TEST_STORE: 'a test store',
    UNKNOWN_STORE: 'another platform',
  },
} as const;
